(function($) { 
  /** 
   * Custom JavaScript codes here
  */

  /** 
   * Example options:

  let options = {
    autostart: true,
    property: 'value',
    onComplete: null,
    duration: 20000,
    padding: 10,
    marquee_class: '.notifications-slider',
    container_class: '.notifications-slider__wrapper',
    sibling_class: 0,
    hover: true,
    velocity: 0.1
    direction: 'right'
  }

  $('.notifications-slider__wrapper').SimpleMarquee(options);
  */

  if ( $('.notifications-slider__wrapper').length ) { 
    let options = {
      duration: 50000,
      velocity: 0.05,
      hover: false,
    }

    $('.notifications-slider__wrapper').SimpleMarquee(options)
  }
})(jQuery);